import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { KeywordsPage } from './pages/keywords.page'
import { GeoActions } from '../../actions/geo-actions'
import { CustomerActions } from '../../actions/customer-actions'
import { KeywordMutations } from '../../graphql/mutations/keyword.mutations'
import { KeywordQueries } from '../../graphql/queries/keyword.queries'
import { KeywordsRoutingModule } from './keywords-routing.module'
import { ModalModule } from '../modal/modal.module'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { PopoverModule } from 'ngx-bootstrap/popover'
import { KeywordsLayout } from './keywords-layout'
import { NewKeywordPage } from './pages/new-keyword.page'
import { EditKeywordPage } from './pages/edit-keyword.page'
import { KeywordFormModule } from './keyword-form/keyword-form.module'
import { VideoFormModule } from './video-form/video-form.module'
import { MatDialogModule } from '@angular/material/dialog'
import { SaveKeywordDialog } from './save-keyword-dialog.component'
import { WriterAvatarModule } from '../writer-avatar/writer-avatar.module'
import { TenTopicsPurchaseModal } from './modals/ten-topics-purchase-modal.component'
import { SharedModule } from 'modules/shared/shared.module'
import { KeywordsHelpModal } from './modals/keywords-help-modal.component'
import { CsvReader } from 'src/services/csv-reader'
import { FilterRequestList } from 'modules/keywords/pipes/filter-request-list.pipe'
import { EditRequestPage } from './pages/edit-request.page'
import { PluralizeModule } from 'pipes/pluralize/pluralize.module'
import { RequestItem } from './components/request-item.component'
import { RequestButtons } from './components/request-buttons.component'
import { VideoItem } from './components/video-item.component'
import { RequestDetails } from '././components/request-details.component'
import { MaterialModule } from '../material/material.module'
import { LocalStorage } from 'src/services/local-storage.service'
import { PersistentDropdownModule } from '../persistent-dropdown/persistent-dropdown.module'
import { AdminUploadPage } from './pages/admin-upload/admin-upload.page'
import { AdminUploadQueries } from './pages/admin-upload/admin-upload.queries'
import { BulkUploaderGuard } from './guards/can-activate-bulk-uploader.guard'

@NgModule({
  declarations: [
    KeywordsPage,
    KeywordsLayout,
    NewKeywordPage,
    EditKeywordPage,
    EditRequestPage,
    SaveKeywordDialog,
    TenTopicsPurchaseModal,
    KeywordsHelpModal,
    FilterRequestList,
    RequestItem,
    RequestButtons,
    VideoItem,
    RequestDetails,
    AdminUploadPage
  ],
  entryComponents: [
    SaveKeywordDialog
  ],
  imports: [
    CommonModule,
    KeywordsRoutingModule,
    FormsModule,
    ModalModule,
    BsDropdownModule,
    PopoverModule,
    TooltipModule,
    KeywordFormModule,
    VideoFormModule,
    MatDialogModule,
    WriterAvatarModule,
    SharedModule,
    PluralizeModule,
    MaterialModule,
    PersistentDropdownModule
  ],
  exports: [],
  providers: [
    GeoActions,
    CustomerActions,
    KeywordMutations,
    KeywordQueries,
    CsvReader,
    { provide: Storage, useClass: LocalStorage },
    AdminUploadQueries,
    BulkUploaderGuard
  ],
})
export class KeywordsModule {}
